import { render, staticRenderFns } from "./DisplayCard.vue?vue&type=template&id=c9b50c5e&scoped=true"
import script from "./DisplayCard.vue?vue&type=script&lang=js"
export * from "./DisplayCard.vue?vue&type=script&lang=js"
import style0 from "./DisplayCard.vue?vue&type=style&index=0&id=c9b50c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b50c5e",
  null
  
)

export default component.exports